import { useEffect, useMemo, useRef, useState } from 'react';

// Select con barra de búsqueda. options: [{ value, label, disabled?, hint? }]
export default function SearchSelect({ value, onChange, options, placeholder = 'Buscar…', required, disabled }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const ref = useRef(null);

  const selected = options.find((o) => o.value === value) || null;

  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return options;
    return options.filter((o) => o.label.toLowerCase().includes(s) || (o.hint || '').toLowerCase().includes(s));
  }, [q, options]);

  useEffect(() => {
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  const pick = (o) => {
    if (o.disabled) return;
    onChange(o.value);
    setOpen(false);
    setQ('');
  };

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        disabled={disabled}
        onClick={() => setOpen((v) => !v)}
        className={`input flex items-center justify-between text-left ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
      >
        <span className={selected ? '' : 'text-slate-500'}>{selected ? selected.label : placeholder}</span>
        <span className="ml-2 text-slate-500">▾</span>
      </button>

      {required && <input tabIndex={-1} className="sr-only" value={value || ''} onChange={() => {}} required />}

      {open && !disabled && (
        <div className="absolute z-30 mt-1 max-h-64 w-full overflow-y-auto rounded-lg border border-slate-700 bg-slate-900 shadow-lg">
          <div className="sticky top-0 bg-slate-900 p-2">
            <input
              autoFocus
              className="input"
              placeholder={placeholder}
              value={q}
              onChange={(e) => setQ(e.target.value)}
            />
          </div>
          {filtered.map((o) => (
            <button
              type="button"
              key={o.value}
              disabled={o.disabled}
              onClick={() => pick(o)}
              className={`block w-full px-3 py-2 text-left text-sm ${
                o.disabled
                  ? 'cursor-not-allowed text-slate-600'
                  : o.value === value
                    ? 'bg-indigo-600/20 text-indigo-300'
                    : 'text-slate-300 hover:bg-slate-800'
              }`}
            >
              {o.label}
              {o.hint && <span className="ml-2 text-xs text-slate-500">{o.hint}</span>}
            </button>
          ))}
          {filtered.length === 0 && <div className="px-3 py-4 text-center text-sm text-slate-500">Sin resultados</div>}
        </div>
      )}
    </div>
  );
}
